export const routeName = 'partner-ngos';
export const slugs: Record<string, string> = {
	es: 'ong-colaboradoras',
	en: 'partner-ngos',
	ca: 'ong-collaboradores',
	fr: 'ong-partenaires',
	it: 'ong-partner',
};
export const sitemap = { changefreq: 'monthly', priority: '0.8', lastmod: '2026-08-24' };
